import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["durationSelect", "timeSelect", "submitBtn", "slotsContainer"]
  static values = {
    availabilityBlockId: Number,
    slotsEndpoint: String
  }

  connect() {
    this.durationSelectTarget.addEventListener("change", () => {
      this.updateTimeSlots()
    })

    this.timeSelectTarget.addEventListener("change", () => {
      if (this.timeSelectTarget.value) {
        this.enableSubmitButton()
      } else {
        this.disableSubmitButton()
      }
    })
  }

  updateTimeSlots() {
    const durationMinutes = this.durationSelectTarget.value
    if (!durationMinutes) {
      this.hideSlotsContainer()
      return
    }

    this.fetchSlots(parseInt(durationMinutes))
  }

  fetchSlots(durationMinutes) {
    const url = `${this.slotsEndpointValue}?duration_minutes=${durationMinutes}`

    this.showLoading()

    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error("Failed to fetch available slots")
        return response.json()
      })
      .then(slots => {
        this.populateTimeSlots(slots)
        this.showSlotsContainer()
      })
      .catch(error => {
        console.error("Error fetching slots:", error)
        this.showError("Failed to load available times")
      })
  }

  populateTimeSlots(slots) {
    this.timeSelectTarget.innerHTML = '<option value="">Select time</option>'

    if (slots.length === 0) {
      const option = document.createElement('option')
      option.disabled = true
      option.textContent = "No available times"
      this.timeSelectTarget.appendChild(option)
      this.disableSubmitButton()
      return
    }

    slots.forEach(slot => {
      const option = document.createElement('option')
      option.value = slot.start_at
      option.textContent = slot.formatted_time
      this.timeSelectTarget.appendChild(option)
    })

    this.disableSubmitButton()
  }

  showSlotsContainer() {
    this.slotsContainerTarget.style.display = 'block'
    this.removeError()
  }

  hideSlotsContainer() {
    this.slotsContainerTarget.style.display = 'none'
    this.disableSubmitButton()
  }

  showLoading() {
    this.timeSelectTarget.innerHTML = '<option disabled>Loading...</option>'
  }

  showError(message) {
    this.timeSelectTarget.innerHTML = '<option disabled style="color: red;">Error: ' + message + '</option>'
    this.disableSubmitButton()
  }

  removeError() {
    const errorOption = this.timeSelectTarget.querySelector('option[style*="color: red"]')
    if (errorOption) {
      errorOption.remove()
    }
  }

  enableSubmitButton() {
    this.submitBtnTarget.disabled = false
  }

  disableSubmitButton() {
    this.submitBtnTarget.disabled = true
  }
}
